import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { logError, getCMSObject } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import LoadingIndicator from '../Components/LoadingIndicator';
import SecondChancePromotion from './secondChancePromotion';
import PageNotFound from '../pages/404';

const UrlDetection = ({ user, config }) => {
    const [loading, setLoading] = useState(false);
    const [display404, setDisplay404] = useState(false);

    const validMicrositePromoUrls = getCMSObject('data.microSiteSettings') ?? {};

    useEffect(() => {
        if (typeof validMicrositePromoUrls === 'undefined') {
            setLoading(true);
        } else {
            setLoading(false);

            const currentPath = window.location.pathname.slice(1);

            if (validMicrositePromoUrls.validUrls.includes(currentPath)) {
                setDisplay404(false);
            } else {
                setDisplay404(true);
                logError({
                    errorCode: 'PAGE_NOT_FOUND',
                    severity: 'error',
                    category: 'generic',
                    user,
                    config,
                });
            }
        }
    }, [validMicrositePromoUrls]);

    return <>{loading ? <LoadingIndicator /> : display404 ? <PageNotFound /> : <SecondChancePromotion />}</>;
};

export default connect(mapStateToProps, mapDispatchToProps)(UrlDetection);
